export default "__VITE_ASSET__GOQNXmmE__ 400w, __VITE_ASSET__49kunMU5__ 800w, __VITE_ASSET__Bfbew4cR__ 1024w";